import moment from 'moment';
import angular from 'angular';
import * as R from 'ramda';

export default function EditPreparationItemDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  loaderService,
  savePreparationItemConfirmDialog,
  ssDialogService
) {
  const vm = this;


  vm.handleCloseDialog = handleCloseDialog;
  vm.handleFormSubmit = handleFormSubmit;
  vm.handleDescriptionChange = handleDescriptionChange;
  vm.handleAssignmentChange = handleAssignmentChange;
  vm.handleStatusChange = handleStatusChange;
  vm.newPreparationItem = { ...vm.preparationItem };

  vm.descriptionIsValid = true;

  _activate();

  /** *********************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleFormSubmit($event) {
    if ($scope.editAMPreparationItemForm.$invalid) {
      return Promise.resolve();
    }
    if (!_isValid(true)) {
      // Set the form as unsubmitted since the user needs to make changes
      $scope.editAMPreparationItemForm.$setPristine();
      $scope.editAMPreparationItemForm.$setUntouched();
      return Promise.resolve();
    }
    _formatPreparationItemInputData();
    if ((vm.preparationItemsDefaultDueDate !== null) && (vm.dueDate > vm.preparationItemsDefaultDueDate)) {
      return _openSavePreparationItemConfirmation($event);
    }
    const isNew = vm.newPreparationItem.preparationItemId <= 0;

    if (!isNew && angular.equals(vm.preparationItem, vm.newPreparationItem)) {
      // No need to save
      return _closeDialog();
    }
    loaderService.showViewLoader = true;
    return amSharedModelService.savePreparationItem(vm.newPreparationItem)
      .then((savedPreparationItem) => {
        angular.extend(vm.newPreparationItem, savedPreparationItem);
        angular.extend(vm.preparationItem, vm.newPreparationItem);
        if (isNew) {
          vm.addCallback(vm.preparationItem);
          $rootScope.$broadcast('refreshAMPreparationItems',
            { preparationItemCategoryId: vm.preparationItem.preparationItemCategoryId });
          $rootScope.$broadcast('refreshNotifications');
        }
        return _closeDialog().then(() => {
          $rootScope.$broadcast('refreshAMPreparationItems',
            { preparationItemCategoryId: vm.preparationItem.preparationItemCategoryId });
          // $rootScope.$broadcast('refreshAMPreparationItem',
          //   { preparationItemId: vm.preparationItem.preparationItemId });
          $rootScope.$broadcast('refreshNotifications');
          alerts.success('The Preparation Item has been saved successfully.');
        });
      })
      .catch(() => {
        alerts.error('An error occurred while saving the Preparation Item.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /**
   * Sync statusId and assignedToUser to assignedToUserId
   */
  function handleAssignmentChange() {
    vm.newPreparationItem.assignedToUserId = vm.newPreparationItem.assignedToUser.userId;
    if (vm.newPreparationItem.statusId !== 3) { // Completed
      if (vm.newPreparationItem.assignedToUserId > 0) {
        vm.newPreparationItem.statusId = 2; // Assigned
      } else {
        vm.newPreparationItem.statusId = 1; // Unassigned
      }
    }
  }

  function handleDescriptionChange() {
    const dfdSave = $q.defer();

    if (_isDescriptionValid()) {
      amSharedModelService.checkPreparationItemDescriptionExists(
        vm.newPreparationItem.preparationItemCategoryId,
        vm.newPreparationItem.preparationItemId,
        vm.newPreparationItem.description
      ).then((exists) => {
        if (exists) {
          alerts.error('The Description exists already. Please choose a different description.');
          vm.descriptionIsValid = false;
          dfdSave.reject();
        } else {
          vm.descriptionIsValid = true;
          dfdSave.resolve();
        }
      });
    } else {
      vm.descriptionIsValid = false;
      dfdSave.reject();
    }

    return dfdSave.promise;
  }

  function handleStatusChange() {
    if (vm.newPreparationItem.statusId === 1) { // Unassigned
      vm.completedDate = null;
      vm.newPreparationItem.completedDate = null;
      vm.newPreparationItem.assignedToUserId = -1;
    } else if (vm.newPreparationItem.statusId === 2) { // Assigned
      vm.completedDate = null;
      vm.newPreparationItem.completedDate = null;
      if (vm.newPreparationItem.assignedToUserId > 0) {
        // Don't do anything. There is an assignment already
      } else {
        alerts.error('You cannot change the status to assigned. '
          + 'Please change the assigned user to update to the assigned status.');
        vm.newPreparationItem.statusId = 1; // Unassigned
      }
    } else if (vm.newPreparationItem.statusId === 3) { // Completed
      vm.completedDate = moment();
      vm.newPreparationItem.completedDate = moment(vm.completedDate).format('MM/DD/YYYY');
    }
  }

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    // Set Default Values
    if (R.isNil(vm.newPreparationItem.assignedToUserId)) { vm.newPreparationItem.assignedToUserId = -1; }
    if (!R.isNil(vm.newPreparationItem.dueDate)) { vm.dueDate = moment(vm.newPreparationItem.dueDate); }
    if (!R.isNil(vm.newPreparationItem.completedDate)) {
      vm.completedDate = moment(vm.newPreparationItem.completedDate);
    }
    if (!R.isNil(vm.newPreparationItem.customDate1)) { vm.customDate1 = moment(vm.newPreparationItem.customDate1); }
    if (!R.isNil(vm.newPreparationItem.customDate2)) { vm.customDate2 = moment(vm.newPreparationItem.customDate2); }
    if (!R.isNil(vm.newPreparationItem.customDate3)) { vm.customDate3 = moment(vm.newPreparationItem.customDate3); }
    if (!R.isNil(vm.newPreparationItem.customDate4)) { vm.customDate4 = moment(vm.newPreparationItem.customDate4); }
    if (!R.isNil(vm.newPreparationItem.customDate5)) { vm.customDate5 = moment(vm.newPreparationItem.customDate5); }
    vm.contentPaneIsFaded = false;
    vm.currentPreparationItemId = 0;

    loaderService.showViewLoader = true;
    amDataService.getBaseAudit(vm.auditId)
      .then((response) => {
        const defaultDueDate = response.data.newPreparationItemsDefaultDueDate;
        if (defaultDueDate !== null) {
          vm.newPreparationItemsDefaultDueDate = moment(defaultDueDate);
        }
        loaderService.showViewLoader = false;
      });
  }

  function _formatPreparationItemInputData() {
    vm.newPreparationItem.dueDate = formatDate(vm.dueDate, vm.newPreparationItem.dueDate);
    vm.newPreparationItem.completedDate = formatDate(vm.completedDate, vm.newPreparationItem.completedDate);
    vm.newPreparationItem.customDate1 = formatDate(vm.customDate1, vm.newPreparationItem.customDate1);
    vm.newPreparationItem.customDate2 = formatDate(vm.customDate2, vm.newPreparationItem.customDate2);
    vm.newPreparationItem.customDate3 = formatDate(vm.customDate3, vm.newPreparationItem.customDate3);
    vm.newPreparationItem.customDate4 = formatDate(vm.customDate4, vm.newPreparationItem.customDate4);
    vm.newPreparationItem.customDate5 = formatDate(vm.customDate5, vm.newPreparationItem.customDate5);
    vm.newPreparationItem.assignedToUserId = getDefaultedId(vm.newPreparationItem.assignedToUserId);

    function formatDate(vmDate) {
      if (!R.isNil(vmDate)) {
        return moment(vmDate).format('MM/DD/YYYY');
      }
      return null;
    }

    function getDefaultedId(id) {
      return id === -1 ? null : id;
    }
  }

  function _isValid(checkDescription) {
    let isValid = true;

    angular.forEach($scope.editAMPreparationItemForm.$error.pattern, () => {
      isValid = false;
    });
    angular.forEach($scope.editAMPreparationItemForm.$error.required, () => {
      isValid = false;
    });

    if (isValid) {
      isValid = _areDatesValid();
    }

    if (isValid) {
      if (!_hasBothAssignedUserAndDueDateOrNeither()) {
        alerts.error('If the Due Date or Assigned User is entered, then both must be set in the PreparationItem.');
        isValid = false;
      }
    }

    if (isValid && checkDescription) {
      if (!vm.descriptionIsValid) {
        alerts.error('There is an issue with the Preparation Item Description.');
        isValid = false;
      }
    }

    return isValid;
  }

  function _areDatesValid() {
    let isValid = true;
    angular.forEach($scope.editAMPreparationItemForm.$error.parse, (item) => {
      if ((item.$name === 'editPreparationItemCompletedDate')
        || (item.$name === 'editPreparationItemDueDate')
        || (item.$name === 'editPreparationItemCustomDate1')
        || (item.$name === 'editPreparationItemCustomDate2')
        || (item.$name === 'editPreparationItemCustomDate3')
        || (item.$name === 'editPreparationItemCustomDate4')
        || (item.$name === 'editPreparationItemCustomDate5')) {
        if (!R.isNil(item.$modelValue) && (!moment(item.$modelValue).isValid())) {
          isValid = false;
        }
      } else {
        isValid = false;
      }
    });
    return isValid;
  }

  function _isDescriptionValid() {
    let isValid = true;

    if (!vm.descriptionIsValid) {
      alerts.error('There is an issue with the Preparation Item Description.');
      isValid = false;
    }

    return isValid;
  }

  function _hasBothAssignedUserAndDueDateOrNeither() {
    // Is assigned to user
    const a = vm.newPreparationItem.assignedToUserId && vm.newPreparationItem.assignedToUserId > -1;
    // Has a due date
    const b = !!vm.dueDate;

    if (a || b) return a && b; // has both?
    return true; // has neither
  }

  function _openSavePreparationItemConfirmation($event) {
    loaderService.showViewLoader = true;
    ssDialogService.dialogs.auditTrail.savePreparationItemConfirmDialog = ssDialogService.alert(
      savePreparationItemConfirmDialog.getOptions($event, {
        customerId: vm.customerId,
        auditId: vm.auditId,
        statuses: vm.statuses,
        users: vm.users,
        preparationItem: vm.preparationItem,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.auditTrail.savePreparationItemConfirmDialog);
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.editPreparationItemDialog);
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.auditTrail.editPreparationItemDialog);
  }
}

EditPreparationItemDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'loaderService',
  'savePreparationItemConfirmDialog',
  'ssDialogService'
];
